<template>
    <div class="menu-button-container">
        <button class="draggable-item-menu-btn draggable-item-menu-btn-green draggable-item-menu-btn-start-finish" @click="openModal">
            Iniciar
        </button>
        <transition name="slide-fade">
            <StartOrderReferenceButtonActionModal
                v-if="showModal"
                :closeModal="closeModal"
                :orderReferenceId="orderReferenceId"
                :endOfAction="endOfAction"
            />
        </transition>
    </div>
</template>

<script>
import { showCustomSuccessSweetAlert, showCustomErrorSweetAlert } from '../../../../../common/utils';
import StartOrderReferenceButtonActionModal from './StartOrderReferenceButtonActionModal.vue';
export default {
    name: "StartOrderReferenceButton",
    components: {
        StartOrderReferenceButtonActionModal
    },
    data() {
        return {
            showModal: false,
        };
    },
    props: {
        orderReferenceId: {
            type: Number,
            required: true,
        },
        endOfAction: {
            type: Function,
            required: true,
        },
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
    },
};
</script>